declare global {
  interface Window {
    _satellite: { track: (analyticEvent: any) => void };
  }
}

export const triggerAnalyticsEvent = (analyticEvent: string) => {
  window._satellite?.track(analyticEvent);
};
